import { render, staticRenderFns } from "./tooltip-primary.vue?vue&type=template&id=4051bb0a&scoped=true"
import script from "./tooltip-primary.vue?vue&type=script&lang=js"
export * from "./tooltip-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051bb0a",
  null
  
)

export default component.exports